import type { Schemas } from '#shopware';

type CartError = Schemas['CartError'];

const successCodes = ['promotion-discount-added'];

export type useCartNotificationReturn = {
    codeErrorsNotification(): void;
    getErrorsCodes(): CartError[];
};

/**
 * UI composable
 *
 * @returns
 */
export function useCartNotification(): useCartNotificationReturn {
    const { hfpPushError, hfpPushSuccess } = useNotificationHelpers();
    const { consumeCartErrors } = useCart();

    /**
     * Get cart error and display
     *
     * @returns {void}
     */
    const codeErrorsNotification = () => {
        const errors: Schemas['Cart']['errors'] = consumeCartErrors();
        if (!errors || Array.isArray(errors)) return;

        Object.keys(errors).forEach((element) => {
            if (!errors[element]) return;

            if (successCodes.includes(errors[element].messageKey)) {
                hfpPushSuccess(errors[element].message);
            } else {
                hfpPushError(errors[element].message);
            }
        });
    };

    /**
     * Get errors codes without displaying
     *
     * @returns CartError[] | undefined
     */
    const getErrorsCodes = () => {
        const errors: Schemas['Cart']['errors'] = consumeCartErrors();
        if (!errors || Array.isArray(errors)) return [];

        return Object.keys(errors).reduce((acc, element) => {
            const _error = errors[element];
            if (!successCodes.includes(errors[element].messageKey))
                acc.push({
                    messageKey: _error.messageKey,
                    message: _error.message,
                    key: _error.key,
                    level: _error.level as 0 | 10 | 20
                });

            return acc;
        }, [] as CartError[]);
    };

    return {
        codeErrorsNotification,
        getErrorsCodes
    };
}
